import { Link } from 'react-router'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ApplicationIcon } from '@/const'
import clsx from 'clsx'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconOpenInNewOutline } from '@icons/IconOpenInNewOutline'

type MessagesApplicationsApplication = RestSchemas['Messages.Applications.Application']

export function ApplicationLink({ item }: { item: MessagesApplicationsApplication }) {
  return (
    <Link className="text-foreground" to={item.appKey}>
      <div className="group flex items-start gap-x-4">
        <TooltipButton tooltip={item.registered ? 'Registered' : 'Unregistered'}>
          <div
            className={clsx(
              'flex size-10 shrink-0 items-center justify-center rounded-full',
              item.registered ? 'bg-primary/10' : 'bg-offwhite'
            )}
          >
            <ApplicationIcon className={clsx('size-5 text-muted-foreground', item.registered && 'text-primary')} />
          </div>
        </TooltipButton>
        <div className="flex flex-col gap-y-1">
          <span className="text-base text-primary group-hover:underline">{item.appName}</span>
          <span className="text-xs font-light leading-[1.1] text-muted-foreground">{item.description}</span>
        </div>
        <IconOpenInNewOutline className="ml-auto mr-0 hidden size-4 shrink-0 self-center text-primary group-hover:block" />
      </div>
    </Link>
  )
}
